import React from 'react'
import {
  Form,
  FormGroup,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap'
import { sendFeedback } from '../../actions/sessionActions'

class FeedbackModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: this.props.isOpen,
      backdrop: true,
      feedbackSent: false,
      title: '',
      text: '',
    }
  }

  onTitleChange = e => this.setState({ title: e.target.value })

  onTextChange = e => this.setState({ text: e.target.value })

  sendFeedback = e => {
    sendFeedback(this.state.title, this.state.text)
    this.setState({ feedbackSent: true, title: '', text: '' })
  }

  render() {
    return this.state.feedbackSent ? (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        backdrop={this.state.backdrop}
      >
        <ModalHeader toggle={this.props.toggle}>Обратная связь</ModalHeader>
        <ModalBody>Спасибо за Ваш отзыв!</ModalBody>
        <ModalFooter>
          <Button color="success" block onClick={this.props.toggle}>
            Закрыть
          </Button>
        </ModalFooter>
      </Modal>
    ) : (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        backdrop={this.state.backdrop}
      >
        <ModalHeader toggle={this.props.toggle}>Обратная связь</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Input
                value={this.state.title}
                onChange={this.onTitleChange}
                placeholder="Тема отзыва"
                className="text-dark"
              />
            </FormGroup>
            <FormGroup>
              <Input
                id="feedbackText"
                type="textarea"
                value={this.state.text}
                onChange={this.onTextChange}
                placeholder="Ваш отзыв"
                className="text-dark"
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="warning" block onClick={this.sendFeedback}>
            Отправить
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default FeedbackModal



// WEBPACK FOOTER //
// ./src/components/modals/FeedbackModal.js